import { render, staticRenderFns } from "./AdminShipping.vue?vue&type=template&id=45dbd8e4"
import script from "./AdminShipping.vue?vue&type=script&lang=js"
export * from "./AdminShipping.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gl-apistage/apistage.greenlists.com/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('45dbd8e4')) {
      api.createRecord('45dbd8e4', component.options)
    } else {
      api.reload('45dbd8e4', component.options)
    }
    module.hot.accept("./AdminShipping.vue?vue&type=template&id=45dbd8e4", function () {
      api.rerender('45dbd8e4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/pages/AdminShipping.vue"
export default component.exports